import Withdraw from '@/modules/withdraw/Withdraw.vue';
import WithdrawBank from "@/modules/withdraw/components/bank/Bank.vue";
import WithdrawPaypal from "@/modules/withdraw/components/paypal/Paypal.vue";

export default [
    {
        path: '/withdraw',
        name: 'Withdraw',
        component: Withdraw,
        meta: { requiresNavbar: true },
        children: [
            {
                path: '/withdraw/',
                name: 'WithdrawBank',
                component: WithdrawBank,
                meta: { requiresNavbar: true },
            },
            {
                path: '/withdraw/paypal',
                name: 'WithdrawPaypal',
                component: WithdrawPaypal,
                meta: { requiresNavbar: true },
            },
        ]
    }
]
